module.exports = __webpack_public_path__ + "img/headset1.abc6907a.jpg";